export default {
    // 商品默认图片
    defaultImg: "upload/default/default_img/goods.png",
    // 商品等级默认图片
    defaultLevelImg: "upload/default/default_img/goodsLevel.png",
}
